(()=>{
 const init=root=>{
  root.querySelectorAll('[data-muemio-product]').forEach(section=>{
   if(section.dataset.ready)return;
   section.dataset.ready='true';
   const gallery=section.querySelector('.gallery'),main=gallery.querySelector('.gallery-main img'),dialog=section.querySelector('[data-image-dialog]');
   gallery.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{
    main.src=button.dataset.image;main.alt=button.querySelector('img').alt;
    gallery.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   }));
   const openImage=()=>{dialog.querySelector('img').src=main.src;dialog.querySelector('img').alt=main.alt;dialog.showModal();};
   main.tabIndex=0;main.setAttribute('role','button');main.addEventListener('click',openImage);main.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();openImage();}});
   dialog.querySelector('button').addEventListener('click',()=>dialog.close());
   dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});
   const form=section.querySelector('.muemio-form'),buttons=section.querySelectorAll('.buy-button');
   const consentDialog=section.querySelector('[data-consent-dialog]'),consentForm=consentDialog.querySelector('[data-consent-form]');
   const closeConsent=consentDialog.querySelector('[data-consent-close]'),submitConsent=consentDialog.querySelector('[data-consent-submit]'),consentFeedback=consentDialog.querySelector('[data-consent-feedback]');
   let busy=false;
   const close=()=>{if(!busy)consentDialog.close();};
   closeConsent.addEventListener('click',close);
   consentDialog.addEventListener('cancel',e=>{if(busy)e.preventDefault();});
   consentDialog.addEventListener('click',e=>{if(e.target===consentDialog){const rect=consentDialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)close();}});
   buttons.forEach(button=>button.addEventListener('click',()=>{
    if(!form||button.disabled||busy)return;
    consentForm.reset();consentFeedback.textContent='';
    consentDialog.showModal();
   }));
   if(form)form.addEventListener('submit',e=>{e.preventDefault();if(!busy&&buttons[0]&&!buttons[0].disabled){consentForm.reset();consentFeedback.textContent='';if(!consentDialog.open)consentDialog.showModal();}});
   consentForm.addEventListener('submit',async e=>{
    e.preventDefault();
    if(!form||busy||buttons[0]?.disabled||!consentForm.reportValidity())return;
    const consent=consentForm.querySelector('[data-digital-consent]'),terms=consentForm.querySelector('[data-terms-consent]');
    if(!consent.checked||!terms.checked)return;
    const body=new FormData(form);
    body.set('properties[Zgoda na natychmiastowe dostarczenie]',consentForm.querySelector('[data-consent-text]').textContent.trim());
    body.set('properties[Akceptacja regulaminu]','Muemio 2026-10-06');
    body.set('properties[_Wersja zgody]','Muemio 2026-10-06');
    body.set('properties[_Czas zgody UTC]',new Date().toISOString());
    busy=true;consent.disabled=true;terms.disabled=true;closeConsent.disabled=true;submitConsent.disabled=true;submitConsent.setAttribute('aria-busy','true');
    consentFeedback.textContent=section.dataset.loading;
    try{
     const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body});
     const data=await response.json();if(!response.ok)throw Error(data.description||section.dataset.error);
     window.location.assign((window.Shopify?.routes?.root||'/')+'checkout');
    }catch(error){
     busy=false;consent.disabled=false;terms.disabled=false;closeConsent.disabled=false;submitConsent.disabled=false;submitConsent.removeAttribute('aria-busy');
     consentFeedback.textContent=error.message||section.dataset.error;consentFeedback.tabIndex=-1;consentFeedback.focus();
    }
   });
   const sticky=section.querySelector('[data-sticky-buy]'),hero=section.querySelector('.hero');
   const observer=new IntersectionObserver(entries=>{sticky.classList.toggle('is-visible',!entries[0].isIntersecting);},{threshold:0});observer.observe(hero);
  });
 };
 init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();
